"use client"
import React from 'react';

interface ContentComponentProps {
    title: string;
    titleColor: string;
    titleSize: string;
    titlePosition: string;
    sectionDescription: string;
    sectionBackgroundColor: string;
}

const ContentComponent = ({ data }: { data: ContentComponentProps }) => {

    const sectionBackgroundColor = data.sectionBackgroundColor ? data.sectionBackgroundColor : '#99ADFC1A';
    const titlePosition = data.titlePosition ? data.titlePosition : 'left';
    return (
        <div className="relative flex justify-center flex-col pt-8 md:pt-20" 
            style={{ backgroundColor: sectionBackgroundColor}}>
            <div className="container mx-auto xl:px-0 px-6">
                {data.title && (
                    <h2
                        className={`font-bold 
                        ${data.titleSize === 'Small' ? 'text-[24px] leading-[32px]' : data.titleSize === 'Medium' ? 'text-[32px] leading-[40px]' : 'text-[48px] leading-[58px]'}`}
                        style={{ color: data.titleColor, textAlign: titlePosition as any}}
                        dangerouslySetInnerHTML={{ __html: data.title }}></h2>
                )}
            </div>
        </div>
    )
}

export default ContentComponent